export interface OpenUserInboxMessagePushNotificationClickAction {
	type: "openUserInboxMessage";
	actionId: string;
	messageId: number;
}

export type PushNotificationClickAction = OpenUserInboxMessagePushNotificationClickAction;

export function parsePushNotificationClickAction(
	messageContent: unknown,
	actionId: string = crypto.randomUUID(),
): PushNotificationClickAction | null {
	if (messageContent == null || typeof messageContent !== "object") return null;
	const data = messageContent as Record<string, unknown>;
	if (data.action === "OPEN_USER_INBOX_MESSAGE" && typeof data.messageId === "number") {
		return {
			type: "openUserInboxMessage",
			actionId,
			messageId: data.messageId,
		};
	}
	return null;
}
